import { DEFAULT_SHADOW_CONFIG } from '@fluentui/merge-styles';
import * as React from 'react';
export var noop = function noop() {
  return false;
};
export var noopShadow = function noopShadow() {
  return DEFAULT_SHADOW_CONFIG;
};
export var noopRootStylesheets = function noopRootStylesheets() {
  return new Map();
};
export var noopUndefined = function noopUndefined() {
  return undefined;
};
export var getNewContext = function getNewContext() {
  return {
    stylesheets: new Map(),
    useAdoptedStylesheetEx: noop,
    useAdoptedStylesheet: noop,
    useShadowConfig: noopShadow,
    useMergeStylesShadowRootContext: noopUndefined,
    useHasMergeStylesShadowRootContext: noop,
    useMergeStylesRootStylesheets: noopRootStylesheets,
    useWindow: noopUndefined,
    useStyled: noopUndefined
  };
};
export var MergeStylesDefaultContext = React.createContext(getNewContext());